import { ApiError } from '../instance/error';
import { getErrorEntry, getStatusEntry } from './error-code-entry';
import { ErrorAction } from './types';

export interface ResolvedErrorAction {
  action: ErrorAction;
  handled: boolean;
  i18nKey?: string;
}

export function resolveErrorAction(error: ApiError): ResolvedErrorAction {
  const resolved = getErrorEntry(error.code) ?? getStatusEntry(error.status);

  if (!resolved) {
    return { action: { type: 'boundary' }, handled: false };
  }

  return {
    action: resolved.action,
    handled: resolved.action.type !== 'boundary',
    i18nKey: resolved.i18nKey,
  };
}
